<template>
    <v-container>
        <contact-edit-dialog
            v-model="newContactDialog.show"
            :item="newContactDialog.item"
            @success="editSuccess"
        >
        </contact-edit-dialog>

        <v-dialog v-model="value" scrollable persistent max-width="350px" :fullscreen="$vuetify.breakpoint.xsOnly">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{title ? title : $t('menu.contacts')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="$emit('input', false)">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-divider></v-divider>
                <v-card-text @scroll="onScroll">

                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-text-field
                              @input="searchContacts"
                              :label="$t('action.search')"
                              v-model="search"
                              clearable
                              clear-icon="close"
                              append-icon="search"
                              :loading="searching"
                            >
                            </v-text-field>
                        </v-flex>

                        <v-flex xs12 v-if="showGroupFilter">
                            <v-select
                                    v-model="selected_group"
                                    :items="groupItems"
                                    item-value="id"
                                    item-text="name"
                                    label="Group filter"
                                    clearable
                            />
                        </v-flex>
                    </v-layout>
                    <v-layout text-xs-center>
                        <v-flex xs12>
                            <v-list
                                two-line
                            >
                                <v-list-tile
                                    v-if="!eventId && !groupId && !teamId && !personalContact"
                                    avatar
                                    :key="0"
                                >
                                    <v-list-tile-action>
                                        <v-checkbox
                                          readonly
                                          off-icon="fa-plus"
                                          on-icon="fa-plus"
                                          @click="newContactDialog.show = true"
                                        >
                                            <div slot="label">
                                                <div class="font-weight-bold">{{$t('contact.new_contact')}}</div>
                                            </div>
                                        </v-checkbox>
                                    </v-list-tile-action>
                                </v-list-tile>

                                <v-checkbox
                                        v-model="select_all"
                                        :label="$t('action.select_all') + ' (' + contacts.length + ')'"
                                        class="mt-0"
                                />

                                <template
                                  v-for="contact in contacts"
                                >
                                    <v-list-tile
                                            avatar
                                            :key="contact.id"
                                            v-if="multipleSelect"
                                    >
                                        <v-list-tile-action>
                                            <v-checkbox
                                                    v-model="contact.selected"
                                            >
                                                <div slot="label">
                                                    <div class="font-weight-bold">{{contact.name}}</div>
                                                    <div>{{contact.areaCode}} {{contact.phone}}</div>
                                                </div>
                                            </v-checkbox>
                                        </v-list-tile-action>
                                    </v-list-tile>

                                    <v-list-tile
                                            @click="returnContact(contact)"
                                            avatar
                                            :key="contact.id"
                                            v-else
                                    >
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{contact.name}}</v-list-tile-title>
                                            <v-list-tile-sub-title>{{contact.areaCode}} {{contact.phone}}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </template>

                            </v-list>
                        </v-flex>
                    </v-layout>
                    <v-layout v-if="loading" text-xs-center>
                        <v-flex xs12>
                            <v-progress-circular
                              indeterminate
                              color="primary"
                            ></v-progress-circular>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions class="flex-wrap" v-if="multipleSelect">


                    <v-checkbox
                            v-if="show_add_to_group_checkbox"
                            v-model="is_add_to_group"
                            :label="$t('contact.add_to_group_desc')"
                            class="mt-0 pl-2 pb-2"
                            hide-details
                    />
                    <div class="flex-break"></div>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="$emit('input', false)">{{$t('action.cancel')}}</v-btn>
                    <v-btn color="blue darken-1" flat @click="returnContacts()" :disabled="multipleSelect && !has_selected_item">{{$t('action.confirm')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import RequestHandler from '~/utils/request-handler'
    import {UrlServices} from "~/utils/url-manager"
    import formatter from '~/utils/formatter'
    import axios, { CancelToken } from 'axios'
    import ContactEditDialog from '~/components/contact/ContactEditDialog'
    export default {
        components: {
            ContactEditDialog
        },
        props: {
            value: Boolean,         // Set true to show. Do NOT change this name so that we can use v-model in parent components
            title: String,          // Dialog title
            exclude: Array,         // Contacts to be exclude from the selection list
            eventId: Number,        // Get user contacts by event invitations
            groupId: Number,        // Get user contacts by group
            teamId: Number,         // Get user contacts by team / personal account
            personalContact: {
                type: Boolean,
                default: false
            },
            multipleSelect: {       // Set true to allow select multiple contacts
                type: Boolean,
                default: true
            },
            defaultSearchString: {
                type: String,
                default: ""
            },
            show_add_to_group_checkbox: {
                type: Boolean,
                default: false
            },
            showGroupFilter: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                is_add_to_group: false,
                is_select_all: false,
                bottomReached: true,
                page: 1,
                loading: true,
                contacts: [],
                search: '',
                searching: false,
                cancel: () => {},
                selected_group: null,
                newContactDialog: {
                    show: false,
                    item: {
                        id: 0,
                        name: '',
                        areaCode: '+852',
                        phone: ''
                    }
                },
                groupItems: []
            }
        },
        watch: {
            value: function(newValue) {
                if (newValue) {
                    //console.log('exclude', this.exclude);
                    if(this.defaultSearchString === ""){
                        this.search = '';
                    }else {
                        this.search = this.defaultSearchString;
                    }

                    if(this.showGroupFilter){
                        this.selected_group = null;
                        this.getGroupItems();
                    }

                    this.is_select_all = false;
                    this.is_add_to_group = false;
                    this.bottomReached = true;
                    this.getContacts(this.search);
                } else {
                    // Reset data
                    this.page = 1;
                    this.loading = true;
                    this.contacts = [];
                    this.groupItems = [];
                }
            },
            selected_group: function(val) {

                this.contacts = [];
                this.getContacts(this.search);

            }
            // defaultSearchString: function(val){
            //     this.search = val;
            // }
        },
        computed: {
            select_all: {
                get: function() {
                    return _.every(this.contacts, 'selected');
                },
                set: function(value) {
                    _.each(this.contacts, function(item) {
                        item.selected = value;
                    });
                }
            },
            has_selected_item: {
                get: function() {
                    return _.some(this.contacts, 'selected');
                }
            }
        },
        methods: {
            getGroupItems() {
                let me = this;

                let params = {
                    record_per_page: 0
                };

                if(me.personalContact){
                    params['get_personal_data'] = 1;
                }

                if(me.teamId){
                    params['tid'] = me.teamId;
                }

                RequestHandler.Get(UrlServices.createUrl({'name': 'api_contact_group_list'}), params, {
                    'success': function (data) {
                        _.each(data.data, x => {
                            me.groupItems.push(x);
                        });
                    }
                })
            },
            getContacts: _.debounce(function(search) {
                //console.log('getContacts', search);
                let me = this;

                let config = {
                    cancelToken: new CancelToken(function executor(c) {
                        me.cancel = c;
                    })
                };

                let params = {
                    page: me.page,
                    search: search,
                    event: me.eventId,
                    group: me.groupId,
                    tid: me.teamId,
                    personal_contact: me.personalContact ? 1 : 0,
                    record_per_page: 0,
                };

                if(this.showGroupFilter && this.selected_group){
                    params['group'] = this.selected_group;
                }

                this.loading = true;

                //TODO filter contacts when retrieving contacts from database intead of filtering from response data
                RequestHandler.Get(UrlServices.createUrl({'name': 'api_contact_list'}), params, {
                    'success': function (data) {
                        //console.log(data.data);
                        data.data.map(x => {
                            x.selected = !!me.eventId || !!me.groupId;  // By default select all contacts if event or group is specified
                            formatter.parsePhone(x);
                        });
                        _.each(data.data, x => {
                            if (!_.some(me.exclude, {areaCode: x.areaCode, phone: x.phone}) && !_.some(me.contacts, {areaCode: x.areaCode, phone: x.phone})) {
                                me.contacts.push(x);
                            }
                        });

                        me.loading = false;
                        me.searching = false;
                        if (me.page < data.total_page) {
                            me.bottomReached = false;
                        }
                        me.page++;
                    }
                }, config)
            }, 0),
            searchContacts: _.debounce(function(search) {
                this.cancel();
                this.page = 1;
                this.searching = true;
                this.contacts = _.filter(this.contacts, x => {
                    return x.selected;
                });
                this.$nextTick(function() {
                    this.getContacts(search);
                });
            }, 500),
            returnContacts() {
                this.$emit('success', _.filter(this.contacts, x => {
                    return x.selected;
                }), this.is_add_to_group);
            },
            returnContact(contact) {
                this.$emit('success', contact, this.is_add_to_group);
            },
            onScroll(e) {
                if ((e.target.offsetHeight + e.target.scrollTop) >= e.target.scrollHeight) {
                    // you're at the bottom of the page
                    if (!this.bottomReached) {
                        this.bottomReached = true;
                        this.loading = true;
                        this.getContacts(this.search);
                    }
                }
            },
            editSuccess(data) {
                //console.log('editSuccess', data);

                let newItem = {
                    id: data.id,
                    name: data.name,
                    phone: data.phone,
                    selected: true
                };
                this.contacts.unshift(formatter.parsePhone(newItem));

                this.newContactDialog.show = false;
                getApp.snackbar = {
                    show: true,
                    color: 'green',
                    text: this.$t('app.msg_edit_success'),
                    timeout: 3000
                };
            }
        },
        mounted() {
        }
    }
</script>

<style scoped>
    .flex-break {
        flex-basis: 100%;
        height: 0;
    }

    .flex-wrap {
        justify-content: flex-end;
        flex-wrap: wrap;
    }
</style>